import "./Social.css";

import arrow from "../../Images/Icons/arrow.png";


import whatsapp from "../../Images/Icons/whatsapp.png";
import pintrest from "../../Images/Icons/pintrest.png";
import facebook from "../../Images/Icons/facebook.png";
import linkedin from "../../Images/Icons/linkedin.png";
import behance from "../../Images/Icons/behance.png";
import instagram from "../../Images/Icons/instagram.png";


import { useNavigate } from "react-router-dom";
import Headline from "../Headline/Headline";
const Social = () => {
    const LinkTo = useNavigate();
    return (
        <>
            <div className="socialSec">
                <div className="socialSecTitle">
                    <Headline text={"Social"}/>
                </div>
                <div className="listLinkSocial">
                    <div onClick={()=> LinkTo("https://wa.me/9816185204")} className="socialLink">
                        <div className="textSocial">
                            <span>Whatspapp</span>
                            <span>Whatspapp</span>
                        </div>
                        <div className="iconSocial">
                            <img src={whatsapp} alt="" />
                            <img src={arrow} alt="" />
                        </div>
                    </div>

                    <div onClick={()=> LinkTo("https://www.pinterest.com/bhanubhakta_sapkota/")} className="socialLink">
                        <div className="textSocial">
                            <span>Pintrest</span>
                            <span>Pintrest</span>
                        </div>
                        <div className="iconSocial">
                            <img src={pintrest} alt="" />
                            <img src={arrow} alt="" />
                        </div>
                    </div>

                    <div onClick={()=> LinkTo("https://www.facebook.com/profile.php?id=61580502718042")} className="socialLink">
                        <div className="textSocial">
                            <span>Facebook</span>
                            <span>Facebook</span>
                        </div>
                        <div className="iconSocial">
                            <img src={facebook} alt="" />
                            <img src={arrow} alt="" />
                        </div>
                    </div>
                    <div onClick={()=> LinkTo("https://www.instagram.com/thevisualdesigner.co/  ")} className="socialLink">
                        <div className="textSocial">
                            <span>Instagram</span>
                            <span>Instagram</span>
                        </div>
                        <div className="iconSocial">
                            <img src={instagram} alt="" />
                            <img src={arrow} alt="" />
                        </div>
                    </div>
                    <div onClick={()=> LinkTo("https://www.linkedin.com/in/bhanubhakta-sapkota-8a8b2b387/")} className="socialLink">
                        <div className="textSocial">
                            <span>Linkedin</span>
                            <span>Linkedin</span>
                        </div>
                        <div className="iconSocial">
                            <img src={linkedin} alt="" />
                            <img src={arrow} alt="" />
                        </div>
                    </div>
                    <div onClick={()=> LinkTo("https://www.behance.net/bhanubhsapkota1")} className="socialLink">
                        <div className="textSocial">
                            <span>Behance</span>
                            <span>Behance</span>
                        </div>
                        <div className="iconSocial">
                            <img src={behance} alt="" />
                            <img src={arrow} alt="" />
                        </div>
                    </div>
                </div>

                
            </div>
        </>
    )
}
export default Social;